export enum PlaybackType {
  Play,
  Pause,
  Speed,
  Skip,
  Jump,
}
